import { gql } from "@apollo/client"
export const GET_SUBSCRIPTIONS = gql`
query GetSubscriptions{
  subscriptions {
          id
          name
          description
  }
}`;